import { Heart, Star } from "lucide-react";

export default function Marquee({ items = [], variant = "pink", reverse = false }) {
  const cls = variant === "pink"
    ? "bg-bde-pink text-white"
    : "bg-bde-ink text-bde-cream";
  const animation = reverse ? "animate-marquee-reverse" : "animate-marquee";
  return (
    <div className={`${cls} overflow-hidden border-y-2 border-bde-ink relative`} data-testid="venues-marquee">
      <div className={`flex whitespace-nowrap ${animation} py-4`}>
        {[...items, ...items].map((item, i) => (
          <span
            key={i}
            className="mx-6 inline-flex items-center gap-4 font-mono uppercase tracking-[0.22em] text-sm md:text-base"
          >
            {item}
            <Star className="h-3 w-3 fill-current" />
          </span>
        ))}
      </div>
    </div>
  );
}
